import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getMessageSettings } from "../../../utils/helpers";
import { MessagePreview } from "../../modal/_ModalConfirmRcs";
const PreviewWhatsapp = ({ data }) => {
  const { whtemplate } = data;
  return (
    <div className="bg-gray-50 px-4 py-2 rounded-lg grid gap-2">
      <div className="text-xs uppercase tracking-wide text-gray-500 font-bold">
        Whatsapp
      </div>

      <span className="text-sm font-medium text-gray-800 bg-gray-200 rounded-lg px-3 py-2 mt-1">
        {whtemplate}
      </span>
    </div>
  );
};

const PreviewEmail = ({ data }) => {
  const { email_message, email_subject } = data;

  const createMark = (html) => {
    return { __html: html };
  };
  return (
    <div className="bg-gray-50 px-4 py-2 rounded-lg grid gap-2">
      <div className="text-xs uppercase tracking-wide text-gray-500 font-bold">
        Email
      </div>
      <div className="px-4 py-2 border-b border-gray-100 bg-gray-50/60">
        <div className="flex items-center justify-between border p-1 rounded-lg">
          <div className="min-w-0">
            <div className="text-md font-semibold text-gray-900 truncate">
              Asunto del correo
            </div>
            <span className="text-xs text-gray-500 truncate">
              {email_subject}
            </span>
          </div>
        </div>
        <div className="border rounded-lg rounded-lg px-3 py-2 mt-1">
           <div className="min-w-0">
            <div className="text-md font-semibold text-gray-900 truncate">
              Mensaje del correo
            </div>
          <span
            className="text-sm font-medium text-gray-800 bg-gray-200 rounded-lg"
            dangerouslySetInnerHTML={createMark(email_message)}
          ></span>
          </div>
        </div>
      </div>
    </div>
  );
};
const PreviewRcs = ({ data }) => {
  const renderMessage = (step) => {
    switch (step) {
      case 1:
        return (
          <>
            <MessagePreview step={step} data={data} />{" "}
          </>
        );

      case 2:
        return (
          <>
            <MessagePreview step={step} data={data} />{" "}
          </>
        );

      case 3:
        return (
          <>
            {data.carrousel &&
              data.carrousel.map((item, index) => {
                return (
                  <div key={index} className="mb-4 border rounded-lg p-1">
                    <div className="text-md font-bold text-gray-700 bg-gray-50 p-1 rounded-lg mb-2">
                      Mensaje {index + 1}
                    </div>
                    <MessagePreview
                      step={step}
                      data={{
                        ...item,
                        rcsmessage: item.description,
                        title_rcs_message: item.title,
                      }}
                    />
                  </div>
                );
              })}
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-gray-50 px-4 py-2 rounded-lg grid gap-2">
      <div className="text-xs uppercase tracking-wide text-gray-500 font-bold">
        RCS
      </div>

      {renderMessage(data.step)}
    </div>
  );
};
const PreviewSms = ({ data }) => {
  const { count, maxCharacters, messages } = useMemo(() => {
    const { limit } = getMessageSettings(data.fallback);
    return {
      count: data.message ? data.message.length : 0,
      maxCharacters: limit,
      messages: data.message ? Math.ceil(data.message.length / limit) : 0,
    };
  }, [data.message]);
  return (
    <div className="bg-gray-50 px-4 py-2 rounded-lg grid gap-2">
      <div className="text-xs font-bold uppercase tracking-wide text-gray-500">
        SMS
      </div>
      <div className="text-sm font-medium text-gray-800 bg-gray-200 rounded-lg px-3 py-2 mt-1">
        {data.message ?? "---"}
      </div>

      <span className="text-[10px] font-semibold px-2 text-yellow-800 ">
        {count}/{maxCharacters} Caracters (Se enviaran {messages} SMS)
      </span>
    </div>
  );
};
const MessageChannelPreview = ({ data }) => {
  return (
    <>
      {data.isSms && <PreviewSms data={data} />}

      {data.isRcs && <PreviewRcs data={data} />}

      {data.isWhatsapp && <PreviewWhatsapp data={data} />}

      {data.isEmail && <PreviewEmail data={data} />}
    </>
  );
};

MessageChannelPreview.propTypes = {
  data: PropTypes.object,
};

PreviewSms.propTypes = {
  data: PropTypes.object,
};

PreviewRcs.propTypes = {
  data: PropTypes.object,
};
PreviewEmail.propTypes = {
  data: PropTypes.object,
};
PreviewWhatsapp.propTypes = {
  data: PropTypes.object,
};
export default MessageChannelPreview;
